<div class="container">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-transparent p-0">
          <ul class="nav nav-pills nav-fill">
            <li class="nav-item">
              <a
                class="nav-link"
                aria-current="page"
                [routerLink]="[
                  '/mig-form',
                  module.corporation$.value?.code,
                  'wizard',
                  'community'
                ]"
                [ngClass]="{ active: module.step > 0 }">
                <div class="flex">
                  <span class="indicator"> 1 </span>
                  <span> Initial Data </span>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link disabled"
                [routerLink]="[
                  '/mig-form',
                  module.corporation$.value?.code,
                  'wizard',
                  'community'
                ]"
                [ngClass]="{ active: module.step > 1 }">
                <div class="flex">
                  <span class="indicator"> 2 </span>
                  <span> Resident Name </span>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link disabled"
                href="#"
                [ngClass]="{ active: module.step > 2 }">
                <div class="flex">
                  <span class="indicator"> 3 </span>
                  <span> Form Type </span>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link disabled" href="#">
                <div class="flex">
                  <span class="indicator"> 4 </span>
                  <span> Form Move In </span>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body">
          <router-outlet></router-outlet>
        </div>
        <div class="card-footer">
          <div class="row justify-content-between">
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-soft-primary"
                (click)="module.onPrevious.emit()">
                Previous Step
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-primary"
                (click)="module.onSubmit.emit()">
                Next Step
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
